import type {MgidUnit} from '../shared/config';

declare global { interface Window { _mgq?:unknown[][] } }

export function mgid(host:HTMLElement,unit:MgidUnit) {
  if(!unit.domains.includes(location.hostname))throw new Error('MGID publisher domain not allowed');
  if(!/^\d+$/.test(unit.siteId)||!/^\d+$/.test(unit.widgetId))throw new Error('Invalid MGID configuration');
  host.dataset.type='_mgwidget';
  host.dataset.widgetId=unit.widgetId;
  if(unit.minHeight)host.style.minHeight=`${unit.minHeight}px`;
  const src=`https://jsc.mgid.com/site/${unit.siteId}.js`;
  window._mgq??=[];
  // The provider queue discovers newly mounted widgets, including late lazy loads.
  window._mgq.push(['_mgc.load']);
  if(!Array.from(document.scripts).some(script=>script.src===src)) {
    const script=document.createElement('script');
    script.src=src;script.async=true;
    script.onerror=()=>{
      script.remove();host.remove();
      window.dispatchEvent(new CustomEvent('felixads:event',{detail:{unit:unit.id,event:'sdkerror',message:'MGID loader failed'}}));
    };
    document.head.append(script);
  }
}
